import React, {useCallback, useState} from "react";
import { Modal } from "./modal.js";
function Saved( {
    api,
    hasSaved,
    user,
    title
} ) {
    const [saveState, setSaveState] = useState(hasSaved === "true");
    const [modalPresent, setmodalPresent] = useState(user === "false");
    const [showModal, setShowModal] = useState(false);

    function handleClick() {
        if(user === 'true' ) {
            fetch( api)
              .then( ( response ) => {
                if ( response.status === 200 ) {
                  setSaveState(!saveState);
                }
                if ( !response.ok ) {
                    throw new Error( 'Something went wrong');
                }
                return response.json();
            })
            .catch((e) => {
                console.log("error")
            });
        } else {
          setShowModal(true);
        }
    }

    // set showMOdal to false
    const closeModalPopup = () => {
        setShowModal(false);
    };

    const buttonClasses = useCallback(() => {
      let classes = [ 'card__save' ];

      if (saveState) {
        classes.push('card__save--active');
      }

      return classes.join(' ');
    }, [ saveState ]);

    return(

        <>

            <button
                className={buttonClasses()}
                onClick={handleClick}
                aria-label={title}
            >

            <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.7746 0.91333H2.23912C1.54397 0.91333 0.933594 1.48912 0.933594 2.17066V14.8837C0.933594 15.1118 0.996657 15.302 1.09829 15.4489C1.21984 15.6245 1.41555 15.7251 1.62542 15.7251C1.82383 15.7251 2.03508 15.6361 2.23017 15.4684L6.04893 12.2038C6.16687 12.1024 6.33629 12.0443 6.51244 12.0443C6.68852 12.0443 6.85758 12.1024 6.97587 12.2041L10.7819 15.4679C10.9776 15.6361 11.1743 15.7251 11.3724 15.7251C11.7074 15.7251 12.0338 15.465 12.0338 14.8838V2.17066C12.0338 1.48912 11.4697 0.91333 10.7746 0.91333Z" fill="#C1CCD0"/>
            </svg>
            </button>
            {modalPresent ? <Modal showmodal={showModal} closeModalPopup={closeModalPopup} /> : null}
        </>
    )
}
export default Saved;
